import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@fountain/ui-kit/components/grid';
import Form from '@fountain/ui-kit/components/form';
import Button from '@fountain/ui-kit/components/button';

const propTypes = {
  invalid: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  submit: PropTypes.func.isRequired,
};

export default function ChangePasswordForm({
  handleSubmit,
  invalid,
  submitting,
  submit,
}) {
  return (
    <Form onSubmit={handleSubmit(submit)}>
      <Grid>
        <Grid.Row>
          <Grid.Col sm="12">
            <Form.Password
              fullWidth
              id="password"
              name="password"
              placeholder="New Password"
            />
          </Grid.Col>
        </Grid.Row>
        <Grid.Row>
          <Grid.Col sm="12">
            <Form.Password
              fullWidth
              hideStrength
              id="passwordConfirmation"
              name="passwordConfirmation"
              placeholder="Re-type Password"
            />
          </Grid.Col>
        </Grid.Row>
        <Grid.Row>
          <Grid.Col sm="12">
            <Button
              disabled={invalid || submitting}
              type="submit"
            >
              Confirm Password
            </Button>
          </Grid.Col>
        </Grid.Row>
      </Grid>
    </Form>
  );
}
ChangePasswordForm.propTypes = propTypes;
